import React from 'react'
import ReactDOM from 'react-dom'
import {Router, Route, IndexRoute, hashHistory} from 'react-router'

import 'style/antd-theme.less'

import {IntlProvider} from 'react-intl'

import {LocaleProvider, Modal} from 'antd'
import enUS from 'antd/lib/locale-provider/en_US'

import moment from 'moment'
import 'moment/locale/en-gb'

import _ from 'lodash'

import {Authenticate} from './bundle/auth'
import {Loading} from './ui'

import {Dashboard} from './bundle/dashboard'
import {User} from './bundle/user'
import {Logout} from './bundle/auth'

import {NotFound} from './pages/NotFound.jsx'
import {Docs} from './pages/Docs.jsx'
import {Index} from './pages/Index.jsx'

import {AuthStore} from './api/auth'

import {Layout} from './ui'

// use bluebird promises for improved error handling!
import Bluebird from 'bluebird'
window.Promise = Bluebird

import './style/app.scss'

moment.locale('en-gb')

export default class App extends React.Component {
   constructor(props) {
      super(props)

      this.state = {
         awaitAuth: true,
         auth:      {}
      }

      window.onerror = this.handleThrownErrors.bind(this)
   }

   static get propTypes() {
      return {
         children: React.PropTypes.node.isRequired,
         routes:   React.PropTypes.array.isRequired,
         location: React.PropTypes.object.isRequired
      }
   }

   componentWillMount() {
      AuthStore.addChangeListener(
         (this._listener = () =>
            this.setState({awaitAuth: null === AuthStore.isAuthenticated, auth: AuthStore.auth}))
      )
   }

   componentDidMount() {
      let body = document.getElementsByTagName('body')[0]

      body.className = _.without(body.className.split(' '), 'blockloader-init').join(' ')
   }

   handleThrownErrors(msg, file, line, col, err) {
      let stack = err ? err.stack : null,
         data = {
            message: msg,
            file:    file,
            line:    line,
            column:  col || (window.event && window.event.errorCharacter),
            stack:   stack
         }

      Modal.error({
         title:   'An unexpected error occured',
         content: (
            <div>
               <b>{data.message} in {data.file}:{data.line}#{data.column}</b>
               {data.stack}
            </div>
         )
      })

      return false
   }

   render() {
      let {awaitAuth} = this.state

      return (
         <Loading loading={awaitAuth} text="Waiting for authentication reply from server">
            <Layout routes={this.props.routes} auth={AuthStore.auth} location={this.props.location}>
               {this.props.children}
            </Layout>
         </Loading>
      )
   }
}

ReactDOM.render(
   <IntlProvider locale="en">
      <LocaleProvider locale={enUS}>
         <Router history={hashHistory}>
            <Route path="/" component={App}>

               <IndexRoute component={Index} />

               <Route
                  navigate={true}
                  path="dashboard"
                  name="Dashboard"
                  glyph="home"
                  linkText="Dashboard"
                  getComponent={(loc, callback) => callback(null, Dashboard)}
                  getChildRoutes={(loc, callback) => callback(null, Dashboard.childRoutes)}
                  getIndexRoute={(loc, callback) => callback(null, Dashboard.childRoutes[0])}
               />

               {/*
               <Route
                  navigate={true}
                  name="Documentation"
                  path="docs/*"
                  component={props => <Docs footer={false} {...props} />}
                  linkText="Documentation"
                  glyph="info-sign"
               />
            */}

               <Route
                  name="User"
                  path="user"
                  linkText="User Account"
                  glyph="user"
                  hide={true}
                  getComponent={(loc, callback) => callback(null, User)}
                  getChildRoutes={(loc, callback) => callback(null, User.childRoutes)}
                  getIndexRoute={(loc, callback) => callback(null, User.childRoutes[0])}
               />

               <Route path="auth" name="Authenticate">

                  <IndexRoute name="Authenticate" component={Authenticate} />

                  <Route
                     path="logout"
                     hide={true}
                     getComponent={(loc, cb) => cb(null, Logout)}
                     getChildRoutes={(loc, cb) => cb(null, Logout.childRoutes)}
                     getIndexRoute={(loc, cb) => cb(null, (Logout.childRoutes || [])[0])}
                  />
               </Route>

               <Route path="*" component={NotFound} />
            </Route>
         </Router>
      </LocaleProvider>
   </IntlProvider>,
   document.getElementById('react')
)



// WEBPACK FOOTER //
// lib/App.jsx